module.exports = __webpack_public_path__ + "static/media/content-thuong-mai-2.539c0575.jpg";